import { render, staticRenderFns } from "./AddBoxToOrderModal.vue?vue&type=template&id=16f27c10&scoped=true&"
import script from "./AddBoxToOrderModal.vue?vue&type=script&lang=js&"
export * from "./AddBoxToOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f27c10",
  null
  
)

export default component.exports